import React, { useState, useEffect } from "react";
import { api } from "../api";

const FeaturedBrands = () => {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    api
      .listBrands()
      .then(setBrands)
      .catch(() => setBrands([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!brands.length) return null;

  return (
    <section className="relative z-10 px-4 sm:px-5 pb-28 pt-0 sm:pt-2">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-6 sm:mb-10">
          <span className="inline-block text-[11px] sm:text-xs font-semibold tracking-[0.25em] uppercase text-[#25D366] mb-2">
            Official Partners
          </span>
          <h2 className="font-display font-bold text-2xl sm:text-3xl text-white">Our Featured Brands</h2>
          <p className="text-white/50 text-sm mt-2 max-w-md mx-auto px-4">
            Play on the most trusted and secure gaming platforms.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {brands.map((b, i) => (
            <div
              key={b.id}
              className="group relative rounded-xl sm:rounded-2xl bg-[#1b1d2b]/70 backdrop-blur border border-white/10 p-3 sm:p-5 transition-all duration-300 hover:-translate-y-1.5 fade-in-up overflow-hidden"
              style={{ boxShadow: "0 10px 40px rgba(0,0,0,0.35)", animationDelay: `${i * 0.08}s` }}
            >
              {/* top accent line */}
              <div className="absolute top-0 left-0 right-0 h-1" style={{ background: `linear-gradient(90deg, transparent, ${b.tint}, transparent)` }} />

              {/* hover glow */}
              <div
                className="absolute inset-0 rounded-xl sm:rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
                style={{ boxShadow: `inset 0 0 60px ${b.tint}1f, 0 0 40px ${b.tint}26` }}
              />

              {/* Logo */}
              <div className="relative h-16 sm:h-20 flex items-center justify-center py-2">
                <img src={b.logo} alt={b.name} className="max-h-12 sm:max-h-14 max-w-[90%] object-contain" loading="lazy" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedBrands;
